const KEY = 'asia_device_id';

/** Stable per-device id (localStorage) so re-opening the app refreshes the same
 *  Session row instead of piling up new ones. */
export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return 'no-storage-device';
  }
}
